// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__nFrW5","title":"Images90_title__1JjYw","images":"Images90_images__2jsCm"};